import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Injectable, Injector } from '@angular/core';

import { from, isObservable, Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CompositeRouteGuard implements CanActivate {
  constructor(private router: Router, private injector: Injector) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    let compositeCanActivateObservable: Observable<boolean | UrlTree> = of(true);
    const routeGuards = route.data.routeGuards;
    if (routeGuards) {
      for (const routeGuard of routeGuards) {
        const nextGuard = this.injector.get<CanActivate>(routeGuard);
        const canActivateResult = nextGuard.canActivate(route, state);
        let canActivateObservable: Observable<boolean | UrlTree> = of(true);
        if (typeof canActivateResult === 'boolean') {
          canActivateObservable = of(canActivateResult as boolean);
        }
        if (isObservable(canActivateResult)) {
          canActivateObservable = canActivateResult as Observable<boolean | UrlTree>;
        }
        if (this.isPromise(canActivateResult)) {
          canActivateObservable = from(canActivateResult);
        }
        compositeCanActivateObservable = compositeCanActivateObservable.pipe(
          mergeMap(value => {
            if (!value) {
              return of(false);
            } else {
              return canActivateObservable;
            }
          })
        );
      }
    }
    return compositeCanActivateObservable;
  }

  isPromise(obj: any): obj is Promise<unknown> {
    return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
  }
}
